import React from 'react';

import { ButtonProps } from 'components';

import { cn } from 'domain/core';

interface ActionIconProps extends ButtonProps {
	className?: string;
}
/**
 * Interactive icon
 */
export const ActionIcon = React.forwardRef(
	({ className, children, ...props }: ActionIconProps, ref: any) => {
		return (
			<button
				className={cn(
					'rounded p-1 transition-all',
					'hover:bg-neutral-300',
					'active:translate-y-[1px] active:bg-neutral-400',
					className
				)}
				{...props}
				ref={ref}>
				{children}
			</button>
		);
	}
);
